import { render } from "./Faturas.vue?vue&type=template&id=2cb44e22"
import script from "./Faturas.vue?vue&type=script&lang=js"
export * from "./Faturas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__